import { Map } from 'immutable';
import * as ExpayActions from '../../actions/recharge/expay';
var initialState = Map({
    fetching: null,
    refer: null,
    error: null,
    amount: null,
    createdAt: null,
    invoiceId: null,
    subToken: null,
    checkStatus: null,
    checking: false,
});
export default (function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ExpayActions.FETCH_RECHARGE_EXPAY:
            return state
                .update('fetching', function () { return true; })
                .update('error', function () { return null; })
                .update('checkStatus', function () { return null; })
                .update('amount', function () { return (action.data && action.data.Amount) || null; })
                .update('subToken', function () { return (action.data && action.data.SubToken) || null; });
        case ExpayActions.SUCCESS_FETCH_RECHARGE_EXPAY:
            if (action.data.Error) {
                return state
                    .update('fetching', function () { return false; })
                    .update('error', function () { return action.data.Error; })
                    .update('refer', function () { return null; });
            }
            return state
                .update('fetching', function () { return false; })
                .update('refer', function () { return action.data.Refer && action.data.Refer.toString(); })
                .update('invoiceId', function () {
                var id = action.data.InvoiceId;
                return id != null ? String(id) : null;
            })
                .update('error', function () { return null; })
                .update('checkStatus', function () { return null; })
                .update('createdAt', function () { return Date.now(); });
        case ExpayActions.FAILURE_FETCH_RECHARGE_EXPAY:
            return state
                .update('fetching', function () { return false; })
                .update('error', function () { return -100; });
        case ExpayActions.FETCH_CHECK_EXPAY_STATUS:
            return state
                .update('checking', function () { return true; })
                .update('checkStatus', function () { return null; });
        case ExpayActions.SUCCESS_FETCH_CHECK_EXPAY_STATUS: {
            var status_1 = action.data.Status;
            var updates = state
                .update('checking', function () { return false; })
                .update('checkStatus', function () { return status_1 || null; });
            if (status_1 === 'SUCCESS' && action.data.Amount != null) {
                return updates.update('amount', function () { return action.data.Amount; });
            }
            if (action.data.Subtoken != null) {
                return updates.update('subToken', function () { return action.data.Subtoken; });
            }
            return updates;
        }
        case ExpayActions.FAILURE_FETCH_CHECK_EXPAY_STATUS:
            return state
                .update('checking', function () { return false; })
                .update('checkStatus', function () { return 'ERROR'; });
        case ExpayActions.CLEAR_RECHARGE_EXPAY:
            return initialState;
        default:
            return state;
    }
});



// WEBPACK FOOTER //
// ./src/reducers/recharge/expayRechargeReducer.js